export default __webpack_public_path__ + "static/media/shopwell.b2129580.png";